var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"video",staticClass:"video-js vjs-default-skin vjs-big-play-centered",style:({height:_vm.height}),attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm._f("cdnurl")(_vm.src)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }